<template>
  <div class="container-fluid">
    <form @submit.prevent="login" class="login">
      <div class="mb-4">
        <el-input placeholder="Přihlašovací jméno" v-model="form.username" />
      </div>
      <div class="mb-4">
        <el-input type="password" placeholder="Heslo" v-model="form.password"/>
      </div>
      <div class="mb-4">
        <el-button native-type="submit">
          Přihlásit se
        </el-button>
      </div>
      <div class="mb-4" style="color: red" v-if="loginError">
        Přihlašovací údaje nejsou správné
      </div>
      <div class="mb-4" style="color: red" v-if="passwordExpred">
        Platnost hesla vypršela. Změňte si prosím heslo kliknutím na odkaz níže.
      </div>
      <div class="mb-4">
        <router-link :to="{
          name: 'resetPassword'
        }">
          Změna nebo obnovení hesla
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      loginError: false,
      passwordExpred: false,
    }
  },
  methods: {
    login() {
      this.loginError = false
      this.passwordExpred = false
      if (this.form.username.length && this.form.password.length) {
        this.$store.dispatch('login', this.form)
          .then(response => {
            this.$router.push({
              name: 'data'
            })
          })
          .catch(error => {
            if (error.response.code === 'PASSWORD_EXPIRED') {
              this.passwordExpred = true
            } else {
              this.loginError = true
            }
          })
      }
    }
  }
}
</script>

<style scoped>
.login {
  margin-top: 100px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}
</style>
